import { api } from "../../services/Api.js";

export function get_newsletters({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token

   
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
  

    // return chainable promise
    return api
    .post(school,"get_newsletters.php",payload)
    .then( result =>{ 
     
      commit('SET_NEWSLETTERS', {store_key:payload.store_key, newsletters:result.data});
      
    })
    .catch( () => {
      
      //
    })
   

}